const MultipleChoice = ({ question, activeQuestionAnswer, playAudio }) => {
  const studentSelectedId = activeQuestionAnswer?.answer;

  return (
    <div className="options-list mt-2">
      {question.options?.map((option, index) => {
        const isSelected = Array.isArray(studentSelectedId)
          ? studentSelectedId.includes(option.id)
          : studentSelectedId === option.id;

        const isCorrect = option.correct === true;

        let bgColor = "#fff";
        let borderColor = "#e0e0e0";
        let textColor = "#4a4a4a";

        if (isSelected && isCorrect) {
          bgColor = "#8dc63f";
          borderColor = "#8dc63f";
          textColor = "#fff";
        } else if (isSelected && !isCorrect) {
          bgColor = "#ff7675";
          borderColor = "#ff7675";
          textColor = "#fff";
        } else if (isSelected) {
          bgColor = "#9bd3ec";
          borderColor = "#9bd3ec";
        } else if (isCorrect) {
          borderColor = "#8dc63f";
        }

        return (
          <div
            key={option.id}
            className="option-item-card p-2 mb-2 rounded d-flex align-items-center justify-content-between"
            style={{
              backgroundColor: bgColor,
              border: `1px solid ${borderColor}`,
              color: textColor,
            }}
            dir="rtl"
          >
            <div className="d-flex align-items-center flex-grow-1 gap-3">
              <div
                className="option-number d-flex align-items-center justify-content-center bg-white"
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  border: "1px solid #7bc6e8",
                  color: "#4a4a4a",
                  fontWeight: "bold",
                  fontSize: "14px",
                  flexShrink: 0,
                }}
              >
                {index + 1}
              </div>
              <span
                className="option-text fw-medium"
                style={{ textAlign: "right" }}
              >
                {option.text}
              </span>
            </div>

            <div className="d-flex align-items-center gap-2">
              {option.audio && (
                <button
                  className="btn btn-link p-0"
                  style={{
                    color: "#000000",
                    cursor: "pointer",
                  }}
                  onClick={() => playAudio(option.audio)}
                  title="Play Audio"
                >
                  <i className="ri-volume-up-line fs-5"></i>
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MultipleChoice;
